import {CommandStatusType} from '../command-response';
import {User} from '../user/user.interface';
import {IdDescriptionPair} from '../user/users-query-result';

export class AccessPoint {
  id: string;
  name: string;
  description: string;
  isSecured: boolean;
  isOpen: boolean;
  isLockdown: boolean;
  alerts: AccessPointAlert[];
  type: string;
  outputType: string;
  secureRequestStatus: CommandStatusType;
  openRequestStatus: CommandStatusType;
  peripherals: Peripheral;
  accessGroups: AccessGroupDto[];
  users: AccessPointOccupants[];
  events: AccessPointEventDto[];
  direction: AccessPointDirection;
  panelId: number;
  doorDefaultTimeSeconds: number;
  outputOpenTimeSeconds?: number;
  doorPreviousTimeSeconds: number;
  isDualAuthentication: boolean;
  isAntipassbackEnabled: boolean;
  isInterlock: boolean;
  isMusterEnabled: boolean;
  isMonitorEnabled?: boolean;
  isBiometricsEnabled: boolean;
  remainingTime: any;
  openUntil: Date;
}

export class DoorPrevTime{
  id: string;
  doorPreviousTimeSeconds: number;
}
export interface AccessPointAlert {
  type: AccessPointAlertType;
  time: number;
  timeString?: string;
}

export enum AccessPointAlertType {
  HeldOpen = 'Held',
  ForceOpen = 'Forced',
}

export enum PeripheralType {
  Reader = 'Reader',
}

export class Peripheral {
  readers: ReaderPeripheral[];
}

export class ReaderPeripheral extends Peripheral {
  brand: PeripheralType;
  direction: AccessPointDirection;
  accessLevel: string;
  name: string;
}

export enum AccessPointDirection {
  Exit = 'EXIT',
  Entry = 'ENTRANCE',
  TwoWay = 'TWO_WAY',
}

export interface AccessPointPermission {
}

export interface AccessGroupDto {
  name: string;
  memberCount: number;
  timezones: string[];
  accessLevel: number;
}

export class AccessPointUserDto extends User {
  avatar: string;
  activeTimezone: boolean;
  accessLevelName: string;
  lastAccess: Date;
}

export class AccessPointOccupants {
  id: number;
  avatar: string;
  firstName: string;
  middleName: string;
  lastName: string;
  accessLevelId: number;
  accessLevelName: string;
  lastAccess: Date;
  activeTimezone: boolean;
  imageBase64: string;
  hasActiveTimezone: boolean;
  isActive: boolean;
  lastAccessEventDate: any;
  timezones: Timezone[];
}
export interface Timezone {
  id: number;
  isActive: boolean;
  name: string;
}

export interface AccessPointEventDto {
  id: string;
  name: string;
  userName: string;
  source: string;
  time: Date;
}

export interface AccessPointDetailsResult {
  accessPoint: AccessPoint;
}

export interface AccessPointResults {
  results: AccessPoint[];
  totalCount: number;
}

export interface AccessPointsQeuryResult {
  accessPoints: AccessPointResults;
}

export interface AccessPointsOccupantsResult {
  results: AccessPointOccupants[];
  totalCount: number;
}

export interface AccessPointsGroupsResult {
  results: AccessGroupDto[];
  totalCount: number;
}

export interface AccessPointsOccupantsQeuryResult {
  occupants: AccessPointsOccupantsResult;
}

export interface AccessPointsAccessGroupsQeuryResult {
  accessGroups: AccessPointsGroupsResult;
}

export interface DoorConfigurationResult {
  configurations: DoorConfiguration;
}
export interface DoorConfiguration {
  doorConfigurations: DoorConfigurationMetaData;
}
export interface DoorConfigurationMetaData {
  doorTypes: IdDescriptionPair[];
  doorStatus: IdDescriptionPair[];
}
